import { createFileRoute } from "@tanstack/react-router";
import { PlaceEditorView } from "@/lib/features/admin/PlaceEditorView";
export const Route = createFileRoute("/_app/admin/platser/$id")({
  component: PlaceEditorView
});